export const SOURCE_SEARCH = 'copayEPASourceSearch';
export const SOURCE_GET = 'copayEPASourceGet';
export const SOURCE_GET_SETTING = 'copayEPAGetSetting';
export const SOURCE_FILTERS_GET = 'copayEPASourceFilterGet';
export const SOURCE_FILTER_ADD = 'copayEPASourceFilterAdd';
export const SOURCE_FILTER_REMOVE = 'copayEPASourceFilterRemove';
export const SOURCE_FILTER_REQUESTAPPROVAL = 'copayEPASourceFilterRequestApproval';
export const SOURCE_FILTER_APPROVE = 'copayEPASourceFilterApprove';
export const SOURCE_FILTER_DENY = 'copayEPASourceFilterDeny';
export const SOURCE_FILTER_PUBLISH = 'copayEPASourceFilterPublish';
export const SOURCE_FILTER_VIEW_ACTIVE = 'copayEPASourceFilterViewActive';
export const SOURCE_FILTER_CANCEL = 'copayEPASourceFilterCancel';
export const SOURCE_FILTER_SAVE = 'copayEPASourceFilterSave';
export const SOURCE_PHARMACY_ADD = 'copayEPASourcePharmacyAdd';
export const SOURCE_PHARMACY_REMOVE = 'copayEPASourcePharmacyRemove';
export const SOURCE_PHARMACY_SAVE = 'copayEPASourcePharmacySave';
export const SOURCE_PHARMACY_REQUESTAPPROVAL = 'copayEPASourcePharmacyRequestApproval';
export const SOURCE_PHARMACY_APPROVE = 'copayEPASourcePharmacyApprove';
export const SOURCE_PHARMACY_PUBLISH = 'copayEPASourcePharmacyPublish';
export const SOURCE_PHARMACY_VIEW_ACTIVE = 'copayEPASourcePharmacyViewActive';
export const SOURCE_PHARMACY_CANCEL = 'copayEPASourcePharmacyCancel';



// WEBPACK FOOTER //
// ./src/store/copay-epa-source/actions.type.js